export default "__VITE_ASSET__BAFrfNTF__"